import { appRelease } from '@constants/appRelease';
import { useLocalization } from '@lib/localization';
import { CardContent, Paper, Typography } from '@mui/material';
import { CardHeader, CardTitle } from './Settings.styled';

/** The release this page was built as, the same one the server's `/config` reports. */
const VersionCard = () => {
  const { t } = useLocalization();

  return (
    <Paper sx={{ mb: 2 }}>
      <CardHeader>
        <CardTitle variant="h6">{t('Common_Version')}</CardTitle>
      </CardHeader>
      <CardContent style={{ padding: '24px' }}>
        <Typography variant="body1">
          {appRelease.version}
          {appRelease.commit && (
            <Typography component="span" variant="body2" color="text.secondary" sx={{ ml: 1 }}>
              ({appRelease.commit})
            </Typography>
          )}
        </Typography>
      </CardContent>
    </Paper>
  );
};

export default VersionCard;
